export default class SpreeResponseContentError extends Error {
};
